import { SIGNUS_APP_URL } from './constants';

export function withLoginRedirect(destination: string): string {
  return `${SIGNUS_APP_URL}/login?returnUrl=${encodeURIComponent(destination)}`;
}

export function appUrl(path: string): string {
  return `${SIGNUS_APP_URL}/${path}`;
}
